module.exports = "<app-header></app-header>\r\n<app-profile-selector *ngIf=\"canBeShown\"></app-profile-selector>\r\n<router-outlet></router-outlet>\r\n"